import { useForm } from 'react-final-form';

function useSource() {
	const form = useForm();

	return form.getFieldState('source')?.value;
}

export default useSource;
